import { AreaPosition, AreaSource } from "type/panel/Panel.type";
import {
  AreaPositionNav,
  AreaPositionNavPoint,
} from "./PanelAreaFieldList.type";
import { AREA_EDIT_COLORS, AREA_EDIT_DEFAULT_COLOR } from "constant/panel";

export const fieldInArea = (
  rowStart: number,
  columnStart: number,
  area: AreaPosition
): boolean => {
  const result: boolean =
    columnStart >= area.columnStart &&
    columnStart < area.columnEnd &&
    rowStart >= area.rowStart &&
    rowStart < area.rowEnd;

  return result;
};

export const findAreaFieldIndex = (
  i: number,
  j: number,
  areas: AreaSource[]
): number[] => {
  const result: number[] = [];
  for (let ind = 0; ind < areas.length; ind++) {
    const area: AreaPosition = areas[ind].area;
    if (fieldInArea(j, i, areas[ind].area)) {
      result.push(ind);
    }
  }

  return result;
};

export const areaFieldColors = (indN: number[]): string[] => {
  const colors: string[] = [];
  if (indN.length > 0) {
    for (let k = 0; k < indN.length; k++) {
      const color = AREA_EDIT_COLORS[indN[k]];
      colors.push(color);
    }
  } else {
    colors.push(AREA_EDIT_DEFAULT_COLOR);
  }

  return colors;
};

export const initialAreaPositionNavGet = (): AreaPositionNav => {
  return {
    firstPoint: null,
    secondPoint: null,
  };
};

export const areaPositionNavSelectionGet = (
  areaPositionNav: AreaPositionNav
): AreaPosition | null => {
  let result: AreaPosition | null = null;
  if (
    areaPositionNav.firstPoint !== null &&
    areaPositionNav.secondPoint !== null
  ) {
    result = {
      columnStart: Math.min(
        areaPositionNav.firstPoint.column,
        areaPositionNav.secondPoint.column
      ),
      columnEnd:
        Math.max(
          areaPositionNav.firstPoint.column,
          areaPositionNav.secondPoint.column
        ) + 1,
      rowStart: Math.min(
        areaPositionNav.firstPoint.row,
        areaPositionNav.secondPoint.row
      ),
      rowEnd:
        Math.max(
          areaPositionNav.firstPoint.row,
          areaPositionNav.secondPoint.row
        ) + 1,
    };
  }

  return result;
};

export const areaPositionNavPointUpdate = (
  column: number,
  row: number,
  areaPositionNav: AreaPositionNav
): AreaPositionNav => {
  const result: AreaPositionNav = { ...areaPositionNav };
  const point: AreaPositionNavPoint = {
    column,
    row,
  };
  if (areaPositionNav.firstPoint === null) {
    result.firstPoint = point;
  } else if (areaPositionNav.secondPoint === null) {
    result.secondPoint = point;
  } else {
    result.firstPoint = point;
    result.secondPoint = null;
  }

  return result;
};

export const structureAreasUpdateGet = (
  areas: AreaSource[],
  selectedAreaInd: number | null,
  areaPosition: AreaPosition
): AreaSource[] => {
  const result: AreaSource[] = [...areas];
  if (selectedAreaInd !== null) {
    result[selectedAreaInd].area = areaPosition;
  }

  return result;
};
